// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2I-Nh","buttons":"Footer_buttons__2i89Y"};